import { motion } from "framer-motion";
import { scrollToId } from "@/data";

const links = [
    { label: "Services", id: "services" },
    { label: "Projects", id: "projects" },
    { label: "About", id: "about" },
    { label: "Contact", id: "contact" },
];

export default function Nav() {
    return (
        <motion.header
            initial={{ y: -32, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
            className="fixed inset-x-0 top-0 z-50 mix-blend-difference"
            data-testid="main-nav"
        >
            <div className="flex items-center justify-between px-6 py-5 lg:px-10">
                <button
                    data-testid="nav-logo"
                    onClick={() =>
                        window.location.pathname !== "/"
                            ? window.location.assign("/")
                            : window.__lenis
                            ? window.__lenis.scrollTo(0, { duration: 1.6 })
                            : window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                    className="flex items-baseline gap-2 text-white transition-opacity duration-300 hover:opacity-70"
                >
                    <span className="text-sm font-semibold tracking-[0.32em]">
                        LILIKOOP
                    </span>
                    <span className="hidden font-mono2 text-[10px] tracking-[0.3em] text-white/60 sm:inline">
                        INTERACTIVE SPACES
                    </span>
                </button>

                <nav className="hidden items-center gap-8 lg:flex">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={`nav-link-${l.id}`}
                            onClick={() => scrollToId(l.id)}
                            className="group relative font-mono2 text-[11px] uppercase tracking-[0.24em] text-white/70 transition-colors duration-300 hover:text-white"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 h-px w-0 bg-white transition-[width] duration-300 group-hover:w-full" />
                        </button>
                    ))}
                    <a
                        data-testid="nav-cta"
                        href="/book"
                        className="project-cta rounded-full border border-white/40 px-5 py-2 font-mono2 text-[11px] uppercase tracking-[0.24em] text-white"
                    >
                        Book a Shoot
                    </a>
                </nav>

                <a
                    data-testid="nav-cta-mobile"
                    href="/book"
                    className="project-cta rounded-full border border-white/40 px-4 py-1.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-white lg:hidden"
                >
                    Book a Shoot
                </a>
            </div>
        </motion.header>
    );
}
